<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    html,body,#app{height: 100%;width: 100%}
    body,ol,ul,h1,h2,h3,h4,h5,h6,p,th,td,dl,dd,form,fieldset,legend,input,textarea,select{margin:0;padding:0}
    body{font:14px "Microsoft YaHei","SimSun","ArMicrosoft YaHeiial Narrow",HELVETICA;background:#fff;-webkit-text-size-adjust:100%}
    body{min-width:1200px;}
    a{text-decoration:none}
    a:hover{text-decoration:underline}
    em{font-style:normal}
    li{list-style:none}
    input,button{outline: none}
    select,input[type=button]{-webkit-box-sizing:content-box;-moz-box-sizing: content-box;box-sizing: content-box;}
    input[type=checkbox],input[type=radio]{border: none;background-color: transparent}
    input[type=file]{text-align: center}
    select[disabled]{background-color: #eee}
    img{border:0;vertical-align:middle}
    table{border-spacing:0}
    th{text-align: left}
    p{word-wrap:break-word}
</style>
